import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import {
  BASE_URL,
  BOGO_DELETE,
  BOGO_LIST_COUNT,
  BOGO_LISTING,
  BOGO_STATUS,
  BOGO_VARIANT_LISTING,
} from "../../../Constants/Config";
import { ciUrl } from "../../../Constants/nodeCi";
import axios from "axios";

const initialState = {
  bogoList: [],
  listLoading: false,
  listError: false,

  bogoStatus: {},
  bogoStatusLoading: false,

  bogoVarList: [],
  bogoVarListLoading: false,

  bogoListCount: 0,
  bogoListCountAPILoading: false,
};

export const fetchBogoListing = createAsyncThunk(
  "bogo/fetchBogoListing",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(ciUrl(BOGO_LISTING), dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response)
      if (response.data.status === true) {
        return (response.data?.bogo_list || []).map((item) => ({
          ...item,
          altria_funded_discount: Number(
            item?.altria_funded_discount ?? item?.altriaFundedDiscount ?? 0
          ),
        }));
      }else{
        return []
      }
    } catch (error) {
      // throw new Error("Internal Server Error");
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const changeBogoStatus = createAsyncThunk(
  "bogo/changeBogoStatus",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(BASE_URL + BOGO_STATUS, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log(response)
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      // throw new Error("Internal Server Error");
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
export const deleteBogo = createAsyncThunk(
  "bogo/deleteBogo",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(BASE_URL + BOGO_DELETE, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log("deleteBogo", response.data);
      if (response.data.status === true) {
        return data.bogo_id;
      }
    } catch (error) {
      // throw new Error("Internal Server Error");
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
export const fetchBogoVariantListing = createAsyncThunk(
  "bogo/fetchBogoVariantListing",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;

    try {
      const response = await axios.post(
        ciUrl(BOGO_VARIANT_LISTING),
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(response)
      if (response.status === 200) {
        return response?.data?.result;
      }
    } catch (error) {
      // throw new Error("Internal Server Error");
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchBogoListCount = createAsyncThunk(
  "bogo/fetchBogoListCount",
  async (data, { rejectWithValue }) => {
    const { token, ...dataNew } = data;
    try {
      const response = await axios.post(BASE_URL + BOGO_LIST_COUNT, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log(response)
      if (response.status === 200) {
        return response.data?.total_count;
      }
    } catch (error) {
      // throw new Error("Internal Server Error");
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const bogoListing = createSlice({
  name: "bogo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // BOGO LISTING DATA
    builder.addCase(fetchBogoListing.pending, (state) => {
      state.listLoading = true;
    });
    builder.addCase(fetchBogoListing.fulfilled, (state, action) => {
      state.listLoading = false;
      state.bogoList = action.payload;
    });
    builder.addCase(fetchBogoListing.rejected, (state, action) => {
      state.listLoading = false;
      state.bogoList = [];
      state.listError = action.error.message;
    });

    // BOGO STATUS CHANGE
    builder.addCase(changeBogoStatus.pending, (state) => {
      state.bogoStatusLoading = true;
    });
    builder.addCase(changeBogoStatus.fulfilled, (state, action) => {
      state.bogoStatusLoading = false;
      state.bogoStatus = action.payload;
    });
    builder.addCase(changeBogoStatus.rejected, (state, action) => {
      state.bogoStatusLoading = false;
      state.bogoStatus = [];
    });

    // BOGO DELETE
    builder.addCase(deleteBogo.pending, (state) => {
      state.bogoStatusLoading = true;
    });
    builder.addCase(deleteBogo.fulfilled, (state, action) => {
      state.bogoStatusLoading = false;
      // state.bogoStatus = action.payload;
      // console.log("builder.addCase(deleteBogo",action.payload)
      state.bogoList = state.bogoList.filter((bogo)=> bogo.id !== action.payload)
      // console.log("Updated bogoList:", state.bogoList); 
    });
    builder.addCase(deleteBogo.rejected, (state, action) => {
      state.bogoStatusLoading = false;
      // state.bogoStatus = [];
    });

    // BOGO VARIANT LIST LOADING
    builder.addCase(fetchBogoVariantListing.pending, (state) => {
      state.bogoVarListLoading = true;
    });
    builder.addCase(fetchBogoVariantListing.fulfilled, (state, action) => {
      state.bogoVarListLoading = false;
      state.bogoVarList = action.payload;
    });
    builder.addCase(fetchBogoVariantListing.rejected, (state, action) => {
      state.bogoVarListLoading = false;
      state.bogoVarList = [];
    });

    // BOGO VARIANT LIST COUNT API
    builder.addCase(fetchBogoListCount.pending, (state) => {
      state.bogoListCountAPILoading = true;
    });
    builder.addCase(fetchBogoListCount.fulfilled, (state, action) => {
      state.bogoListCountAPILoading = false;
      state.bogoListCount = action.payload;
    });
    builder.addCase(fetchBogoListCount.rejected, (state, action) => {
      state.bogoListCountAPILoading = false;
      state.bogoListCount = [];
    });
  },
});

export const { emptyBogoVariantList } = bogoListing.actions;
export default bogoListing.reducer;
